// src/lib/api.js

const API_BASE = (process.env.REACT_APP_API_BASE_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8080')).replace(/\/+$/, '');
const API_KEY = process.env.REACT_APP_API_KEY || '';

const getHeaders = () => {
  const headers = { 'Content-Type': 'application/json' };
  if (API_KEY) headers['x-api-key'] = API_KEY;
  // Add auth token if available
  const token = localStorage.getItem('token');
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
};

export const api = {
  get: async (endpoint) => {
    const res = await fetch(`${API_BASE}${endpoint}`, {
      method: 'GET',
      headers: getHeaders(),
    });
    return res;
  },
  post: async (endpoint, body) => {
    const res = await fetch(`${API_BASE}${endpoint}`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(body),
    });
    return res;
  },
  put: async (endpoint, body) => {
    const res = await fetch(`${API_BASE}${endpoint}`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify(body),
    });
    return res;
  },
  delete: async (endpoint) => {
    const res = await fetch(`${API_BASE}${endpoint}`, {
      method: 'DELETE',
      headers: getHeaders(),
    });
    return res;
  },
  patch: async (endpoint, body) => {
    const res = await fetch(`${API_BASE}${endpoint}`, {
      method: 'PATCH',
      headers: getHeaders(),
      body: JSON.stringify(body),
    });
    return res;
  },
  // Add other methods as needed
};

export async function getProducts() {
  const res = await api.get('/api/products');
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Failed to fetch products');
  }
  return res.json();
}

// Legacy method support if needed, or refactor usages
// Legacy method support if needed, or refactor usages
export async function createBooking(payload) {
  const res = await api.post('/api/bookings', payload);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Failed to create booking');
  }
  return res.json();
}

export async function searchAvailability(payload) {
  const res = await api.post('/api/availability/search', payload);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Failed to search availability');
  }
  return res.json();
}

export async function getBookings(role = 'customer') {
  const res = await api.get(`/api/bookings?role=${role}`);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Failed to fetch bookings');
  }
  return res.json();
}

export async function updateBookingStatus(artisanId, startTime, status) {
  // Use 'api.patch' instead of 'api.post' with 'PATCH' argument (which api.post doesn't support)
  const res = await api.patch(`/api/bookings/${encodeURIComponent(artisanId)}/${encodeURIComponent(startTime)}/status`, { status });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Failed to update booking status');
  }
  return res.json();
}
// actually I will implement it using the `api` helper if I can, but `api` helper doesn't have patch.
// So I will implement `updateBookingStatus` using `fetch` directly or add `patch` to `api`.
// I'll add `patch` to `api` in the SAME edit.
// Wait, I see api.patch implemented above in the file content I read.
// So I can just use it.

export async function validatePromo(code) {
  const res = await api.post('/api/bookings/validate-promo', { code });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.message || 'Invalid promo code');
  }
  return res.json();
}
